import type { ReactNode } from 'react';
import { HostChatContext } from './context';
import { useChatView, type ChatViewInput } from './chat/useChatView';
import { OperationsProvider } from './operations/provider';
import { SourcesProvider } from './sources/provider';
import { ComposerProvider } from './composer/provider';
import { ArtifactsProvider } from './artifacts/provider';
import { SourcingProvider } from './sourcing/provider';

/** Product concerns are composed here, above the replaceable Surface. */
export const ApplicationProvider = ({ children, ...input }: ChatViewInput & { children?: ReactNode }) => {
  const view = useChatView(input);
  return <HostChatContext.Provider value={view}>
    <OperationsProvider>
      <SourcesProvider userId={input.options.userId}>
        <ComposerProvider><ArtifactsProvider>
          <SourcingProvider userId={input.options.userId}>{children}</SourcingProvider>
        </ArtifactsProvider></ComposerProvider>
      </SourcesProvider>
    </OperationsProvider>
  </HostChatContext.Provider>;
};
